import autobind from 'core-decorators/lib/autobind';
import { WixConnect } from 'shared/utils/wix-connect';


@WixConnect()
export default class BIUnhandledErrorLogger extends React.Component {

  static propTypes = {
    biError: React.PropTypes.func,
  };

  componentDidMount() {
    global.addEventListener('error', this.sendBIError);

    const previousOnUnhandledRejection = global.onunhandledrejection;

    global.onunhandledrejection = event => {
      this.sendBIError();
      if (previousOnUnhandledRejection) {
        previousOnUnhandledRejection(event);
      }
    };
  }

  componentWillUnmount() {
    global.removeEventListener('error', this.sendBIError);
  }

  @autobind
  sendBIError() {
    try {
      this.props.biError('shared.general.unhandled-exception')
        .catch(_.noop);
    } catch (error) {
      // this is really bad if this section was reached
    }
  }

  render() {
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/shared/bi/bi-unhandled-error-logger.js